import { render, staticRenderFns } from "./CaseInfo.vue?vue&type=template&id=58e6bfa4"
import script from "./CaseInfo.vue?vue&type=script&lang=js"
export * from "./CaseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports